export const SET_AUTHENTICATED_STATUS = 'SET_AUTHENTICATED_STATUS';